module.exports = __webpack_public_path__ + "img/empty-header.98c563a4.png";